import { render, staticRenderFns } from "./_content.vue?vue&type=template&id=b515d044&scoped=true"
import script from "./_content.vue?vue&type=script&lang=ts"
export * from "./_content.vue?vue&type=script&lang=ts"
import style0 from "./_content.vue?vue&type=style&index=0&id=b515d044&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b515d044",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Slide: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/Slide/index.vue').default,VideoSwiper: require('/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/components/VideoSwiper/index.vue').default})
